import { SwiperSlide } from "swiper/react";
import CarouselWrapper from "../Wrapper";
import { GreenCard } from "@components";

export default function CarouselCards({ cards, bg = "bg-green" }) {
    return (
        <CarouselWrapper
            style={{
                "--swiper-theme-color": bg.includes("green")
                    ? "#46CE84"
                    : "#b6d9ff",
                width: "100%",
                marginBottom: 100,
            }}
            slidesPerView={4}
            breakpoints={{
                200: {
                    slidesPerView: 1, // mobile screens
                },
                730: {
                    slidesPerView: 2, // tablet screens
                },
                1200: {
                    slidesPerView: 3, // large screens
                },
                1600: {
                    slidesPerView: 4, // x-large screens
                },
            }}
        >
            {cards.map((card, i) => {
                const props = { ...card, bg };
                return (
                    <SwiperSlide
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        key={i}
                    >
                        <GreenCard {...props} key={card.title} />
                    </SwiperSlide>
                );
            })}
        </CarouselWrapper>
    );
}
